<template>
    <Image360Viewer v-if="has360View" :images="get360Images" :sensitivity="5"/>
</template>

<script>
import Image360Viewer from '../../components/Image360Viewer.vue'
import Axios from 'axios';
import { assetPath } from '../../composables/assetSlug';

export default {
    components: {
        Image360Viewer
    },
    data: () => ({
        unit: null,
        has360View: false,
    }),
    async beforeMount() {
        const response = await Axios.get(`${process.env.MIX_APP_URL}/unit/${this.$route.params.id}?include=project,floor`);
        this.unit = response.data.data;
        this.check360ViewAvailability()
    },
    computed: {
        get360Images() {
            if (this.unit) {
                // Construire le chemin de base
                const basePath = `${process.env.MIX_APP_URL}/storage/v360/${assetPath(this.unit?.project?.name[this.$store.state.config.locale], this.unit?.floor?.building?.name, this.unit?.name)}`;

                // Charger le fichier de configuration
                return Axios.get(`${basePath}/config.json`)
                    .then(response => {
                        const { totalImages } = response.data;
                        const images = [];
                        for (let i = 0; i < totalImages; i++) {
                            const imageNumber = i.toString().padStart(2, '0');
                            images.push(`${basePath}/${imageNumber}.jpg`);
                        }
                        return images;
                    })
                    .catch(error => {
                        console.error('Erreur lors du chargement de la configuration 360°:', error);
                        return [];
                    });
            }
            return Promise.resolve([]);
        },
    },
    methods: {
        async check360ViewAvailability() {
            try {
                const response = await Axios.get(`${process.env.MIX_APP_URL}/storage/v360/${assetPath(this.unit?.project?.name[this.$store.state.config.locale], this.unit?.floor?.building?.name, this.unit?.name)}/config.json`);

                this.has360View = response.data.totalImages ? true : false;
            } catch (error) {
                this.has360View = false;
            }
        }
    }
}
</script>
